/**
 * @file NotificationHistoryDetailsReport.js
 * @description CSV report export configuration and trigger for messages history details report data.
 */

import { getNotificationMessageDetails } from '../../../services/messageService';
import {
    createCsvReportDefinition,
    exportCsvReport,
} from '../../../utils/reporting/csvReportExporter';

const MESSAGES_HISTORY_DETAILS_HEADERS = [
    'Unique ID',
    'Last Name',
    'First Name',
    'Sent',
    'Destination',
];

function expandIndividualToRows(individual) {
    const rows = [];

    const emailRow =
        individual.emails.length > 0
            ? {
                  uniqueId: individual.sourceId,
                  lastName: individual.lastName,
                  firstName: individual.firstName,
                  sent: 'Email',
                  destination: individual.emails.join(', '),
              }
            : null;

    const smsRow =
        individual.smSs.length > 0
            ? {
                  uniqueId: individual.sourceId,
                  lastName: individual.lastName,
                  firstName: individual.firstName,
                  sent: 'SMS',
                  destination: individual.smSs.join(', '),
              }
            : null;

    const pushRow =
        individual.pushes.length > 0
            ? {
                  uniqueId: individual.sourceId,
                  lastName: individual.lastName,
                  firstName: individual.firstName,
                  sent: 'Push Notification',
                  destination: individual.pushes.map(p => p || 'Unknown').join(', '),
              }
            : null;

    if (emailRow) rows.push(emailRow);
    if (smsRow) rows.push(smsRow);
    if (pushRow) rows.push(pushRow);
    return rows;
}

async function getMessagesHistoryDetailsData(
    notificationScheduleId,
    searchTerm,
) {
    const response = await getNotificationMessageDetails(
        notificationScheduleId,
        searchTerm,
    );

    return response.notificationIndividuals;
}

function getMessagesHistoryDetailsReportDefinition(
    notificationScheduleId,
    searchTerm,
) {
    return createCsvReportDefinition({
        headers: MESSAGES_HISTORY_DETAILS_HEADERS,
        filenamePrefix: 'messagesHistoryDetailsReport',
        flattenRows: true,
        getData: () =>
            getMessagesHistoryDetailsData(notificationScheduleId, searchTerm),
        mapRow: expandIndividualToRows,
    });
}

export async function downloadReport(notificationScheduleId, searchTerm) {
    await exportCsvReport(
        getMessagesHistoryDetailsReportDefinition(
            notificationScheduleId,
            searchTerm,
        ),
    );
}
